module.exports = __webpack_public_path__ + "static/media/w.8c085442.jpg";